import {
  CREATE_SERVICE,
  CREATE_SERVICE_FAILURE,
  CREATE_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_FAILURE,
  GET_SERVICES_SUCCESS,
  GET_SINGLE_SERVICE,
  GET_SINGLE_SERVICE_FAILURE,
  GET_SINGLE_SERVICE_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_FAILURE,
  UPDATE_SERVICE_SUCCESS,
} from "./actionTypes";

export const getServices = (payload) => {
  return {
    type: GET_SERVICES,
    payload,
  };
};

export const getServicesSuccess = (payload) => {
  return {
    type: GET_SERVICES_SUCCESS,
    payload,
  };
};

export const getServicesFailure = (payload) => {
  return {
    type: GET_SERVICES_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getSingleService = (payload) => {
  return {
    type: GET_SINGLE_SERVICE,
    payload,
  };
};

export const getSingleServiceSuccess = (payload) => {
  return {
    type: GET_SINGLE_SERVICE_SUCCESS,
    payload,
  };
};

export const getSingleServiceFailure = (payload) => {
  return {
    type: GET_SINGLE_SERVICE_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const createService = (payload) => {
  return {
    type: CREATE_SERVICE,
    payload,
  };
};

export const createServiceSuccess = (payload) => {
  return {
    type: CREATE_SERVICE_SUCCESS,
    payload,
  };
};

export const createServiceFailure = (payload) => {
  return {
    type: CREATE_SERVICE_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updateService = (payload) => {
  return {
    type: UPDATE_SERVICE,
    payload,
  };
};

export const updateServiceSuccess = (payload) => {
  return {
    type: UPDATE_SERVICE_SUCCESS,
    payload,
  };
};

export const updateServiceFailure = (payload) => {
  return {
    type: UPDATE_SERVICE_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteService = (payload) => {
  return {
    type: DELETE_SERVICE,
    payload,
  };
};

export const deleteServiceSuccess = (payload) => {
  return {
    type: DELETE_SERVICE_SUCCESS,
    payload,
  };
};

export const deleteServiceFailure = (payload) => {
  return {
    type: DELETE_SERVICE_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
